import { State } from '@/store/state';
import { ExtensionState } from '@/store/state/ExtensionState';

export const extensionMutations = {
  setExtension(state: State, data: Partial<ExtensionState>) {
    state.extension = { ...state.extension, ...data };
  },
};
